import { AlertTypes } from "@/helpers/enums/AlertTypes";
import { AlertStatus } from "@/helpers/enums/AlertStatus";
import { useStore } from "@/store";
const store = useStore();
import { GeneralActionTypes } from "@/store/modules/general/action-types";
import Toggle from "@vueform/toggle";
import { Roles } from "../enums/Roles";

let configRoute =
  store.getters.loggedInUser.role === Roles.AGMSAdmin
    ? "/alert-console/configuration/live-site-alerts"
    : "/alert-console/configuration/security-alerts";
if (
  store.getters.loggedInUser.role === Roles.SiteAdmin ||
  store.getters.loggedInUser.role === Roles.GroupAdmin
) {
  configRoute = "/alert-console/configuration/security-alerts";
}
const data = {
  readyToUseFilters: {},
  filter: {
    ignoreSaveFilter: true,
    searchResult: true,
    searchText: true,
    title: "newalertfilter",
    pageName: "AlertPageFilter",
    genre: "alertPageFilter",
    filters: [
      {
        title: "companySiteGroup",
        type: "siteAndGroup",
        vmodel: "",
        apiEquivalent: "groupIds",
        param: "name",
        data: [],
      },
      {
        title: "Alarm Type",
        type: "select",
        param: "alarmType",
        vmodel: "",
        placeholder: "Select alarm type",
        data: [
          {
            alarmType: "Security",
            id: 1,
          },
          // {
          //   alarmType: "System",
          //   id: 2,
          // },
          {
            alarmType: "LiveSite",
            id: 0,
          },
          {
            alarmType: "Deployment Health",
            id: 4,
          },
        ],
      },
      {
        title: "Category",
        type: "select",
        param: "title",
        valueParam: "title",
        apiEquivalent: "ruleName",
        placeholder: "Select category",
        vmodel: "",
        source: "Alarm/GetAlarmConditionCategories?conditionCategoryType=-1",
        data: [],
        //GetAlarmConditionCategories
      },

      {
        title: "Status",
        type: "select",
        param: "status",
        vmodel: "",
        placeholder: "Select status",
        data: [
          {
            status: "Unresolved",
            id: 99,
          },
          {
            status: "In Review",
            id: 1,
          },
          {
            status: "Resolved",
            id: 2,
          },
        ],
      },

      {
        title: "search",
        type: "wordstyped",
        apiEquivalent: "searchStr",
        param: "searchStr",
      },
      {
        title: "Time Range",
        type: "date",
        param: "range",
        apiEquivalent: "range",
        hidden: true,
        vmodel: null,
      },
    ],
  },
  header: {
    navigation: [
      {
        title: "all",
        url: "all",
      },
      {
        title: "unresolved",
        url: "unresolved",
      },
      {
        title: "inreview",
        url: "inreview",
      },
      {
        title: "resolved",
        url: "resolved",
      },
    ],
    buttonPosition: "justify-content-between",
    buttons: [
      {
        title: "configuration",
        icon: "manage",
        class: "primary mr-3",
        link: configRoute,
        target: "",
        toggle: "",
      },
    ],
  },
  component: {
    type: "ag-table",
    options: {
      columns: [
        {
          label: "alerttype",
          field: "alarmType",
          sortable: false,
          style: "width:60px",
          display: function (row: any, t: any) {
            let rowType = row.type;
            if (rowType === 3) {
              rowType = 0;
            }
            return (
              '<span class="p-1 ag-ribbon ag-ribbon_' +
              AlertTypes[rowType] +
              '">' +
              t(AlertTypes[rowType]) +
              "</span>"
            );
          },
        },
        {
          label: "status",
          field: "status",
          sortable: false,
          display: function (row: any, t: any) {
            return t(AlertStatus[row.status]);
          },
        },
        {
          label: "endpoint",
          field: "source",
          sortable: false,
        },
        {
          label: "category",
          field: "ruleName",
          sortable: false,
          display: function (row: any, t: any) {
            try {
              const parsed: any = JSON.parse(row.conditionJson);
              switch (row.ruleName) {
                case "New Hash Seen":
                  return (
                    "<div style='display:inline !important'>New <strong>" +
                    parsed[0].DefaultValue.replace("Hash ", "") +
                    " Hash</strong> is Reported</div>"
                  );
                  break;
                case "New Hash Reported":
                  return (
                    "<div style='display:inline !important'>New <strong>" +
                    parsed[0].DefaultValue.replace("Hash ", "") +
                    " Hash</strong> is Reported</div>"
                  );
                  break;

                case "High Event Volume: Critical Severity":
                  return (
                    "<div style='display:inline !important'>More Than <strong>" +
                    parsed[0].DefaultValue +
                    "</strong> Critical Event" +
                    (parsed[0].DefaultValue > 1 ? "s" : "") +
                    " in <strong>" +
                    parsed[1].DefaultValue +
                    " Day" +
                    (parsed[1].DefaultValue > 1 ? "s" : "") +
                    "</strong></div>"
                  );
                  break;

                case "High Event Volume: Block Events by Type":
                  return (
                    "<div style='display:inline !important'>More Than <strong>" +
                    parsed[2].DefaultValue +
                    " " +
                    parsed[0].DefaultValue +
                    "</strong> Event" +
                    (parsed[2].DefaultValue > 1 ? "s" : "") +
                    " in<strong style='padding:0 5px;'>" +
                    JSON.parse(row.conditionJson)[1].DefaultValue +
                    " Day" +
                    (parsed[1].DefaultValue > 1 ? "s" : "") +
                    "</strong> </div>"
                  );
                  break;

                case "Event Volume on a Single Endpoint":
                  return (
                    "<div style='display:inline !important'>More Than <strong>" +
                    parsed[0].DefaultValue.replace("Hash ", "") +
                    "</strong> Event" +
                    (parsed[0].DefaultValue > 1 ? "s" : "") +
                    " in<strong style='padding:0 5px;'>" +
                    JSON.parse(row.conditionJson)[1].DefaultValue +
                    "</strong> Day" +
                    (parsed[1].DefaultValue > 1 ? "s" : "") +
                    "</div>"
                  );
                  break;

                default:
                  if (row.type === 3) {
                    return "Corrupted Files";
                  } else {
                    return row.ruleName;
                  }
              }
            } catch (error) {
              console.log(error);
            }

            if (row.type === 3) {
              return "Corrupted Files";
            } else {
              return row.ruleName;
            }
          },
        },
        // {
        //   label: "scope",
        //   // field: "eventJson",
        //   sortable: false,
        //   components: [
        //     {
        //       component: "tableJsonViewer",
        //       field: "eventJson",
        //     },
        //   ],
        // },
        {
          label: "count",
          field: "alarmCount",
          format: "number",
          sortable: false,
          width: "100px",
        },

        {
          label: "firstalerttime",
          sortable: false,
          components: [
            {
              component: "tableDateFormatter",
              field: "firstSeen",
            },
          ],
        },
        {
          label: "lastalerttime",
          sortable: false,
          components: [
            {
              component: "tableDateFormatter",
              field: "lastSeen",
            },
          ],
        },
        {
          label: "",
          field: "edit",
          width: "100px",
          components: [
            {
              component: "tableExpandComponent",
              filter: () => {
                return data.readyToUseFilters;
              },
            },
          ],
        },
      ],
      rows: [],
      total: 0,
      sortable: {
        order: "",
        sort: "",
      },
      page: 1,
      pageSize: 10,
      isLoading: true,
      dateFilter: true,
      hasCheckbox: false,
      fetchTable: async (options: any) => {
        const filters = data.readyToUseFilters; //data.filter
        const body = { filters, options };
        store.dispatch(GeneralActionTypes.GET_ALERTS, body);
      },
    },
  },
  modals: [
    {
      id: "exampleModalCenter",
      action: {
        label: "Save",
        function: function (arg: any) {
          alert(JSON.stringify(arg));
        },
      },
      cancel: {
        label: "Close",
      },
      items: [
        {
          title: "allalerts",
          component: "ag-alert-detail",
          options: [true],
          filters: () => {
            return data.readyToUseFilters;
          },
        },
        {
          title: "scopedetails",
          component: "ag-scope-detail",
          options: [true],
        },
        {
          title: "xml",
          component: "ag-xml-detail",
          options: [true],
        },
        {
          title: "hashdetails",
          component: "ag-hashdetail",
          options: [true],
        },
        {
          title: "whereFound",
          component: "ag-hashvisibility",
          options: [true],
        },
      ],
    },
  ],
};

export default data;
